<template lang="pug">
  div.legendMap
    img.iconLegend.cursor__pointer(src='@/assets/images/icon/leyenda2.svg' @click='clickDatos' height="36px")
    ods-popover(popper-class="legend__popover" trigger="manual" class="legend__popover-points" v-model="open")
      div.legend__popover-close
        ods-icon.cursor__pointer(name="close" size="16" @click.native="clickDatos")
      // ENVIRNOMENT
      div(v-if="verticalType === 'Parksandgardens'")
        div.legend__popover-elementos(v-if="!data")
          p.legend__popover-title Leyenda
          ul.legend__popover-list
            li(v-for='item in dataLengend')
              p(v-if="item.type === 'point'")
                img(:src="item.img")
                span {{ item.label }}
        div.legend__popover-data(v-else)
          div.containerDataPopup
            div.containerValuesPopup
              ods-tag(type="secondary") {{ $t(datosFinal.subtype) }}
          p {{ $t(datosFinal.name) }}
      div(v-if="verticalType === 'Meteorology'")
        div.legend__popover-elementos(v-if="!data")
          p.legend__popover-title Leyenda
          ul.legend__popover-list
            li(v-for='item in dataLengend')
              p(v-if="item.type === 'point'")
                img(:src="item.img")
                span {{ item.label }}
        div.legend__popover-data(v-else)
          div.containerDataPopup
            div.containerValuesPopup
              ods-tag(type="secondary") {{ $t(datosFinal.subtype2) }}
          p {{ $t(datosFinal.name) }}
      // PARKING AND PANEL PARKING
      div(v-if="verticalType === 'Parking'")
        div.legend__popover-elementos(v-if="!data")
          p.legend__popover-title Leyenda
          ul.legend__popover-list
            li(v-for='item in dataLengend')
              p(v-if="item.type === 'point'")
                img(:src="item.img")
                span {{ item.label }}
        div.legend__popover-data(v-else)
          div.containerDataPopup
            div.containerValuesPopup
              ods-tag(type="secondary") {{ $t(datosFinal.subtype) }}
          p {{ $t(datosFinal.name) }}
          div(v-if="datosFinal.subtype2 == 'Parking' || datosFinal.subtype2 == 'parking'")
            p.label {{ $t("parkings.streetAddress") }}
              span {{ dataParkingCurrent ? dataParkingCurrent.address.streetAddress : ''}}
            p.label {{ $t("parkings.totalSpotNumber") }}
              span {{ datosFinal ? datosFinal.properties.totalSpotNumber : 0 }}
            ods-divider(direction="horizontal" contentPosition="center")
            p.label {{ $t("parkings.availableSpotNumber") }}
              span {{ dataParkingCurrent ? dataParkingCurrent.availableSpot : 0}}
            p.label {{ $t("parkings.occupiedSpot") }}
              span {{ dataParkingCurrent ? dataParkingCurrent.occupiedSpot : 0 }}
            p.label {{ $t("parkings.occupationRate") }}
              span {{ dataParkingCurrent ? dataParkingCurrent.occupationRate : 0 }}
      // BIKE
      div(v-if="verticalType === 'Bike'")
        div.legend__popover-elementos(v-if="!data")
          p.legend__popover-title Leyenda
          ul.legend__popover-list
            li(v-for='item in dataLengend')
              p(v-if="item.type === 'point'")
                img(:src="item.img")
                span {{ item.label }}
        div.legend__popover-data(v-else)
          div.containerDataPopup
            div.containerValuesPopup
              ods-tag(type="secondary") {{ $t(datosFinal.subtype) }}
          p {{ $t(datosFinal.name) }}
      // AUTOBUSES
      div(v-if="verticalType === 'Autobuses'")
        div.legend__popover-elementos(v-if="!data")
          p.legend__popover-title Leyenda
          ul.legend__popover-list
            li(v-for='item in dataLengend')
              p(v-if="item.type === 'point'")
                img(:src="item.img")
                span {{ item.label }}
        div.legend__popover-data(v-else)
          div.containerDataPopup
            div.containerValuesPopup
              div(v-if="datosFinal.subtype2 == 'busRealTime' || datosFinal.subtype2 == 'BusRealTime'")
                span.titLegenda {{ $t(datosFinal.name )}}
                div.maxSizePopup
                  ods-row(type="flex" justify='space-between')
                    ods-col(:span='12')
                      span.tipo {{$t('Modelo')}}:
                      span.valor {{ datosFinal.properties.brandName }}
                    ods-col(:span='12')
                      span.tipo {{$t('Color')}}:
                      span.valor {{ datosFinal.properties.color }}
                    ods-col.ods-mb-0(:span='24')
                      span.tipo {{$t('Categoría')}}:
                      span.valor {{ $t(datosFinal.properties.category) }}
              div(v-if="datosFinal.subtype2 == 'busStop' || datosFinal.subtype2 == 'BusStop'")
                span.titLegenda {{ $t(datosFinal.name )}}
                div.containerValuesPopupLegend__iconLine
                  div.custom-icon
                    i(:class='iconSelected')
                  div.custom-icon(v-for='icon in paradaTeatro' :key="icon.id")
                    i(:class='iconLines + icon' :classIcon='classIcon') {{icon}}
              ods-row(type="flex" justify='left' v-if="datosFinal.subtype === 'busLine'")
                div.custom-icon
                  // i(:class='iconSelected')
                  span.containerDataPopup__nameLine {{ datosFinal.nameLine }}
                span.titLegenda {{ $t(datosFinal.name ) }}
      // FLEETS
      div.containerDataPopup(v-if="verticalType === 'Cruises'")
        div(v-if="!data")
          ods-row(type="flex" justify='space-between')
            span.containerDataPopup__titular Leyenda
          ods-row.legend(v-if="dataLengend.cat != 'mapHot'" class="mapAlert")
            // datos de mapa de puntos Alert
            ods-row.legend__img(type="flex" justify='left')
              div.custom-icon-vertical(v-if="dataLengend.component === 'CRM'")
                img(:src="require('@/assets/images/icon/ico_complaint_blue.svg')").dinamic
              div.custom-icon-vertical(v-else-if="dataLengend.component === 'CruisesMain'")
                img(:src="require('@/assets/images/icon/ico_fleet_blue.svg')").dinamic
              span {{  $t(dataLengend.img) }}
            ods-row.legend__info(type="flex" justify='left')
              div.legend__alert
                div.containerDataPopup__nameAlert(:class='dataLengend.primary')
                span {{ $t(dataLengend.textColorPrimary) }}
              div.legend__alert
                div.containerDataPopup__nameAlert(:class='dataLengend.medium')
                span {{ $t(dataLengend.textColorMedium) }}
              div.legend__alert
                div.containerDataPopup__nameAlert(:class='dataLengend.alert')
                span {{ $t(dataLengend.textColorAlert) }}
        div.legend__popover-data(v-else)
          div.containerDataPopup
            div.containerValuesPopup
              ods-tag(type="secondary") {{ $t(datosFinal.subtype) }}
          p.label {{ $t(datosFinal.name) }} - {{ datosFinal.properties.enrollment}}
          p.label Tipo
            span {{ datosFinal.properties.type }}
          p.label Descripción
            span {{ datosFinal.properties.description }}
        //- div.legend__popover-data(v-else)
        //-   p
        //-     span.containerDataPopup__category {{ datosFinal.properties.deviceData.brand }} {{ datosFinal.properties.deviceData.model }} -
        //-     span
        //-       span.containerDataPopup__brand
        //-       span {{ datosFinal.properties.deviceData.plate }}
        //-   div.containerDataPopup
        //-     div.containerValuesPopup
        //-       ods-tag(type="secondary") {{ $t(datosFinal.properties.deviceData.vehicleType) }}
</template>

<script>

export default {
  name: 'Legend',
  data () {
    return {
      datosType: [],
      iconSelected: 'ods-icon-icon_busStop_isolated',
      paradaTeatro: [1, 7, 8, 10, 11, 17, 54, 64, 'L2', 'L3'],
      iconLines: 'iconLines line',
      open: false,
      data: false
    }
  },
  props: {
    datosFinal: {},
    verticalType: '',
    dataLengend: {},
    dataParkingCurrent: null
  },
  computed: {
    classIcon () {
      return 'iconLines line'
    }
  },
  watch: {
    dataParkingCurrent (newVal, oldVal) {
      this.dataParkingCurrent = newVal
    },
    datosFinal (newVal, oldVal) {
      this.datosFinal = newVal
    }
  },
  methods: {
    clickDatos () {
      this.open = !this.open
      if (!this.open) this.data = false
    }
  }
}
</script>

<style scope lang="scss">
  .legendMap {
    .iconLegend{
      position: absolute;
      left: 0px;
      bottom: 0px;
      z-index: 2;
      margin: 10px;
      cursor: pointer;
      height: 36px;;
    }
    .legend{
      &__popover{
        bottom: 50px;
        left: 10px;
        &-title{
          font-weight: bold;
          margin-bottom: 8px;
        }
        &-close{
          text-align: right;
          display: inline-block;
          width: 100%;
        }
        &-list{
          p{
            display: flex;
            align-items: center;
            margin-bottom: 8px;
          }
          span{
            margin-left: 7px;
          }
        }
        &-data{
          p{
            padding-bottom: 1rem;
            margin: 1rem;
            // border-bottom: 1px solid #d5dce0;
            font-weight: 500
          }
          .label{
            padding-bottom: 0;
            margin: rem(5);
            font-weight: 500;

            span {
              font-weight: 200;
              margin-left: rem(10);
            }

          }
          .containerValuesPopup{
            text-align: center;
          }
        }
      }
    }
    .cursor{
      &__pointer{
        cursor: pointer;
      }
    }
    .containerDataPopup {
      /* border-bottom: 1px solid $--color-neutral-3; */
      padding-bottom: rem(16);
      margin-bottom: rem(5);
      margin-right: rem(8);
      font-weight: 500;
      &__titular{
        font-size: rem(12);
      }
      &__nameAlert{
        color: #fff;
        border-radius: rem(4);
        width: rem(16);
        display: inline-block;
        height: rem(16);
        text-align: center;
        margin-right: rem(10);
      }
      .primary{
        background: #2E6C99;
      }
      .medium{
        background-color: #ED8D2F;
      }
      .alert{
        background-color: #CC1818;
      }
      .ods-row--flex{
        align-items: center;
      }
      .legend{
        display: flex;
        margin-top: rem(20);
        justify-content: space-between;
        &__img{
          font-weight: 400;
          align-items: normal;
          .custom-icon-vertical{
            border-radius: 50%;
            border: solid 1px $--color-blue-dark;
            background: #f3f3f3;
            width: rem(32);
            height: rem(32);
            display: flex;
            justify-content: center;
            margin-right: rem(10);
          }
          span{
            margin-top: 9px;
            font-size: rem(12)
          }
        }
        &__info{
          flex-direction: column;
          align-items: baseline;

        }
        &__alert{
          font-weight: 400;
          display: flex;
          align-items: center;
          padding: rem(5);
          font-size: rem(12)
        }
        &__hot{
          display: flex;
          padding: 10px 0;
          .legend__img{
            padding: 10px 0;
            .colorGradiant{
              border-radius: 8px;
              margin: 0;
              width: 8px;
              background: linear-gradient(180deg, #E37A7A 0%, #F8E97C 29.56%, #A4DFE6 64.27%, #D5CEF0 100%);
            }
          }
          .legend__info{
            padding: 0 0 0 20px;
            .legend__alert{
              line-height: 20px;
            }
          }
        }
      }
      .mapAlert{
        .legend__img{
          margin-right: 47px;
        }
      }
    }
    .containerValuesPopupLegend {
      &__iconLine{
        .iconLines{
          padding: rem(5);
          width: rem(20);
          display: inline-block;
          text-align: center;
          border-radius: rem(4);
          color: #fff;
        }
        .line1{
          background: #048412;
        }
        .line7{
          background: #007EAD;
        }
        .line8{
          background: #FFDE00;
        }
        .line10{
          background: #007EAD;
        }
        .line11{
          background: #048412;
        }
        .line17{
          background: #048412;
        }
        .line54{
          background: #007EAD;
        }
        .line64{
          background: #048412;
        }
        .lineL2{
          background: #007398;
        }
        .lineL3{
          background: #007398;
        }
      }
    }
    .maxSizePopup {
      // max-height: rem(100);
      // padding-right: rem(24);
      text-align: left;
      text-transform: uppercase;
      div {
        margin-bottom: rem(16);
        font-size: rem(10);
        .tipo {
          font-weight: bold;
          margin-right: rem(8);
          &::before{
            background: #048412;
            height: rem(10);
            width: rem(5);
            display: inline-block;
            position: absolute;
          }
        }
        .valor {
          color: $--color-grey-dark;
          font-size: rem(11);
        }
      }
    }
    .titLegenda {
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      margin: 0 0 10px;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LegendMap.vue